<template>
  <article class="gallery-block">
    <a href="/">
      <figure class="gallery-block__image">
        <img :src="getImage" />
      </figure>
    </a>
    <div class="gallery-block__header">
      <h3>
        <TextHeading variant="md">{{ title }}</TextHeading>
      </h3>
      <span class="gallery-block__text">{{ size }}</span>
    </div>
    <BaseButton variant="primary" rounded="full" @click="toggleActive">
      <BaseIcon name="get_app" size="18"></BaseIcon>
    </BaseButton>
  </article>
</template>

<script>
import BaseIcon from '../elements/BaseIcon.vue'
import BaseButton from '../elements/BaseButton.vue'
import TextHeading from '../elements/TextHeading.vue'
export default {
  name: 'CardGallery',
  components: { TextHeading, BaseButton, BaseIcon },
  props: {
    title: {
      type: String,
      default: 'Article title goes here'
    },
    image: {
      type: String,
      default: 'carrier-bags.jpg'
    },
    size: {
      type: String,
      default: '0Mb'
    }
  },
  computed: {
    getImage() {
      return require('@/assets/images/' + this.image)
    }
  },
  data() {
    return {
      isActive: false,
      makeActive: false
    }
  },
  methods: {
    toggleActive() {
      this.isActive = !this.isActive
    }
  }
}
</script>

<style lang="postcss">
.gallery-block {
  @apply bg-white pb-6 w-full;
}
.gallery-block a {
  @apply no-underline text-body;
}
.gallery-block:hover {
  @apply cursor-pointer;
}
.gallery-block:hover .gallery-block__image img {
  transform: scale(1.1);
}
.gallery-block__image {
  @apply aspect-ratio-16/9 bg-body-dark relative overflow-hidden;
}
.gallery-block__image img {
  @apply block absolute inset-y-0 inset-x-0 w-full transition-slow;
}
.gallery-block__header {
  @apply py-4 flex justify-between;
}
.gallery-block__sharer {
  @apply flex justify-between items-center relative pb-6 px-6 border;
}
.gallery-block__text {
  @apply font-semibold;
}
</style>
